import $ from 'jquery';
import {is_function, is_string} from '../../Helpers/js/index';
import LP from './0-lp';
import UI from './0-ui';


// ---------------------
// LAMAPOLL UI
// ---------------------
LP.UI = LP.UI || {
    // --------------
    // Init Shortcuts
    // --------------
    initButtonMenu: function (params) {
        LP.UI.ButtonMenu.init(params);
    },
    initButtons: function (selector) {
        UI.setupButtons(selector);
    },

    // --------------
    // Message Boxes
    // --------------


    //confirmModal with green submit button
    confirm: function (item, onConfirm, onNotConfirm) {
        var text = '';
        if (is_string(item)) {
            text = item;
        } else if ($('.confirmation', item).length > 0) {
            text = $('.confirmation', item).html();
        } else {
            text = item.html();
        }

        UI.showMsgBox(text, UI.MsgBox.mYESNO, onConfirm, onNotConfirm);
        return false;
    },

    //confirmModal with red submit button
    warnConfirm: function (item, onConfirm, onNotConfirm) {
        var text = '';
        if (is_string(item)) {
            text = item;
        } else if ($('.confirmation', item).length > 0) {
            text = $('.confirmation', item).html();
        } else {
            text = item.html();
        }
        UI.showMsgBox(text, UI.MsgBox.wYESNO, onConfirm, onNotConfirm);
        return false;
    },

    // --------------
    // Text Editor Dialog
    // --------------
    openTextEditor: function (href, params, editElement, dialogName, dialogTitle, useContent, showLarge, afterSubmit, beforeSubmit) {
        var dialogWidth,
            dialogHeight;

        if (showLarge) {
            dialogWidth = 750;
            dialogHeight = 450;
        } else {
            dialogWidth = 900;
            dialogHeight = 550;
        }
        LP.Dialog.open({
            ajax: href,
            request: params,
            element: editElement,
            useContent: useContent,
            name: dialogName,
            title: dialogTitle,
            width: dialogWidth,
            height: dialogHeight,
            sizeable: true,
            onLoad: LP.Dialog.TextEditor.onLoad,
            beforeSubmit: LP.Dialog.TextEditor.beforeSubmit,
            afterSubmit: afterSubmit,
            beforeEditorSubmit: beforeSubmit,
            onClose: LP.Dialog.TextEditor.onClose
        });
    },

    // ------------------
    // Content Loading
    // ------------------
    isContentLoading: false,
    isContentFading: false,

    requestContent: function (url, data, params) {
        if (LP.UI.isContentLoading || LP.UI.isContentFading) {
            return;
        }

        if (!params.contentHolder) {
            params.contentHolder = params.content;
        }

        //var statusHolder;
        var loaderInterval;
        var prevStatus;

        // Callback  Funktion
        var onLoaded = function (json) {
            LP.UI.isContentLoading = false;
            params.content.html(json.html);
            if (is_function(params.onLoad)) {
                params.onLoad(json);
            }
            if (!LP.UI.isContentFading) {
                LP.UI.onContentLoaded(params, loaderInterval, prevStatus);
            }
        };
        var onFailed = function (json) {
            LP.UI.isContentLoading = false;
            if (is_function(params.onError)) {
                params.onError(json);
            }
            LP.UI.onContentLoaded(params, loaderInterval, prevStatus);
        };

        // Loading new content
        LP.UI.isContentLoading = true;

        window.Browser.send(url, data, onLoaded, onFailed);
    },

    onContentLoaded: function (params, loaderInterval, prevStatus) {
        if (params.showTimedLoader) {
            clearInterval(loaderInterval);
            $('#lp-temp-loader').remove();
        }

        if (params.useFading) {
            $(params.contentHolder).fadeIn(100, function () {
                LP.UI.jQPlot.loadCharts();
                if (is_function(params.onShow)) {
                    params.onShow();
                }
            });
        } else {
            $(params.contentHolder).show();
            if (is_function(params.onShow)) {
                params.onShow();
            }
        }

        if (params.showPollLoader) {
            $('#lp-poll-status').html(prevStatus);
        }
    }

};
